import { api, ApiError, Me } from './api';

const form = document.querySelector<HTMLFormElement>('#login')!;
const error = document.querySelector<HTMLParagraphElement>('#error')!;
const button = form.querySelector<HTMLButtonElement>('button')!;

// Already signed in: go straight to the game.
api<Me>('/api/auth/me').then(() => location.replace('/play'), () => undefined);

form.addEventListener('submit', async (event) => {
  event.preventDefault();
  const data = new FormData(form);
  error.textContent = '';
  button.disabled = true;
  try {
    await api<Me>('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username: data.get('username'), password: data.get('password') }),
    });
    location.replace('/play');
  } catch (e) {
    error.textContent =
      e instanceof ApiError && e.status === 429 ? 'Too many attempts, wait a minute.' : (e as Error).message;
  } finally {
    button.disabled = false;
  }
});
